import { Injectable } from '@angular/core';

import { NavigationService } from '@core/services/navigation/navigation.service';

import { BaseProductCommand } from '@shared/commands/base-product.command';
import { IProductCommandContext } from '@shared/models/command';
import { ProductTypes } from '@shared/models/products.model';
import { CommandAvailabilityService } from '@shared/services/command-availability.service';

@Injectable({ providedIn: 'root' })
export class EarlyRepaymentCommand extends BaseProductCommand {
  readonly type = 'early-repayment';
  readonly title = 'Досрочное погашение';
  readonly icon = 'refresh';
  readonly productType = ProductTypes.CREDIT;
  readonly isInfoAction = false;
  readonly settingsNames = ['REQUEST/METINV_EARLY_LOAN_REPAYMENT'];
  readonly order = 3; // Третий в actions для credit

  constructor(
    private navigationService: NavigationService,
    commandAvailabilityService: CommandAvailabilityService
  ) {
    super(commandAvailabilityService);
  }

  async execute(context: IProductCommandContext): Promise<void> {
    this.navigationService.push('payments/early-repayment', {
      state: {
        product: context.data
      }
    });
  }
}
